// EmailJS Configuration
// Replace these values with your actual EmailJS credentials
// Create a .env file in the project root with REACT_APP_EMAILJS_PUBLIC_KEY, etc.
// See .env.example for required variables.

export const EMAIL_CONFIG = {
  // Get these from your EmailJS dashboard: https://dashboard.emailjs.com/
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,

  // Your email address where contact form messages will be sent
  recipientEmail: process.env.REACT_APP_RECIPIENT_EMAIL,
};

// Separate template for quote requests
export const QUOTE_EMAIL_CONFIG = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID_QUOTE || "template_quote_request",
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
  recipientEmail: process.env.REACT_APP_RECIPIENT_EMAIL,
};

/** Returns true if EmailJS is configured (public key is required by EmailJS). */
export function isEmailConfigured(config = EMAIL_CONFIG) {
  return Boolean(config?.publicKey?.trim());
}

// EmailJS Template Variables
// These are the variables that will be available in your EmailJS template
export const TEMPLATE_VARIABLES = {
  from_name: "{{from_name}}", // Sender's name
  from_email: "{{from_email}}", // Sender's email
  inquiry_type: "{{inquiry_type}}", // Type of inquiry
  message: "{{message}}", // Message content
  to_email: "{{to_email}}", // Recipient email
};
